module.exports = __webpack_public_path__ + "static/media/GIHousehold.6395fb37.svg";